import { useEffect, useState } from "react";
import { useStore } from "@/context/Store";

export const Preloader = () => {
  const { settings } = useStore();
  const [minDone, setMinDone] = useState(false), [phase, setPhase] = useState("in");
  useEffect(() => { document.getElementById("boot-splash")?.remove(); const a = setTimeout(() => setMinDone(true), 1500), b = setTimeout(() => setPhase((p) => (p === "in" ? "out" : p)), 3500); return () => { clearTimeout(a); clearTimeout(b); }; }, []);
  useEffect(() => { if (minDone && settings && phase === "in") setPhase("out"); }, [minDone, settings, phase]);
  useEffect(() => { if (phase !== "out") return; const t = setTimeout(() => setPhase("gone"), 700); return () => clearTimeout(t); }, [phase]);
  useEffect(() => { document.body.style.overflow = phase === "gone" ? "" : "hidden"; return () => { document.body.style.overflow = ""; }; }, [phase]);
  if (phase === "gone") return null;
  return (
    <div className={`fixed inset-0 z-[100] flex items-center justify-center bg-[var(--ivory)] grain transition-opacity duration-700 ${phase === "out" ? "opacity-0 pointer-events-none" : "opacity-100"}`} role="status" aria-label="Loading REVASTRA" data-testid="preloader">
      <div className="absolute inset-0 bg-[radial-gradient(50%_50%_at_50%_45%,#F3D9D2_0%,transparent_70%)]" />
      <div className="relative flex flex-col items-center">
        <img src="/logo.png" alt="REVASTRA" className="h-36 w-auto" />
        <div className="mt-6 w-48 h-px bg-[var(--rose-soft)] overflow-hidden"><div className="h-full bg-[var(--rose-deep)] preload-bar" /></div>
        <p className="serif italic text-[var(--rose-deep)] mt-4 text-lg preload-tag">One piece. Endless yous.</p>
      </div>
    </div>
  );
};
